<div class="container">
    <div class="row">
        <div class="col-md-12">
            <h1 class="text-center">Coming Soon</h1>
        </div>
    </div>
</div>
